<label [for]="inputId" class="form-label omgui-checkbox-container" [class.disabled]="disabled">
  <input
    data-cy="checkbox-component"
    type="checkbox"
    [id]="inputId"
    [attr.name]="name"
    [attr.value]="value"
    [disabled]="disabled"
    [(ngModel)]="_checked"
    (ngModelChange)="handleChange($event)"
    (blur)="handleTouched()"
    [attr.aria-label]="ariaLabel ? ariaLabel : label ? label.trim() : 'Checkbox'"
    [attr.aria-checked]="_checked"
  />
  <span *ngIf="label && label.trim()">
    {{ label.trim() }}
  </span>
</label>
